import React from 'react';
import { TextButton, Box } from '@wix/design-system';
import { ChevronRight, Languages } from '@wix/wix-ui-icons-common';
import { dataHooks } from '../../utils/constants';
import useMarketplaceHeaderBi, {
  BI_CLICK_DATA,
  BI_CLICK_TYPES,
  IMPHeaderPageName,
} from '@components/Hooks/useMarketplaceHeaderBi';
import { getLanguageLabel } from '@components/Header/utils/Language/formatLanguageOptions';
import { SetActiveMobileScreenCb } from '../MobileScreens';
import s from '../MobileScreens.module.scss';

const ChangeLanguageButton = ({
  pageName,
  language,
  setActiveScreen,
}: {
  setActiveScreen: SetActiveMobileScreenCb;
  pageName: IMPHeaderPageName;
  language: string;
}) => {
  const { reportClick } = useMarketplaceHeaderBi({ pageName });

  return (
    <TextButton
      dataHook={dataHooks.languageSelectorLink}
      skin="dark"
      weight="normal"
      className={s.mobileMenuTextButton}
      suffixIcon={<ChevronRight />}
      onClick={() => {
        reportClick({
          clickType: BI_CLICK_TYPES.profileDropdownMenu,
          clickData: BI_CLICK_DATA.changeLanguage,
        });
        setActiveScreen('language');
      }}
    >
      <Box>
        <Box paddingRight="SP1">
          <Languages />
        </Box>
        {getLanguageLabel(language)}
      </Box>
    </TextButton>
  );
};

export default ChangeLanguageButton;
